import { client } from '@/common-utils/libraries/axios/axios';
import CUSTOMIZATION from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateLabel = (onSuccess, onError) => {
    return {
        mutationFn: ({ uuid, packageLabel }) => {
            return client.put(replaceParameters(CUSTOMIZATION.UPDATE_PACKAGE_CUSTOMIZATION.url, { uuid }), { packageLabel });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateLabel;